import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { SWRConfig } from 'swr';

import Routes from './routes';

import './styles/index.css';

import ScrollToTop from '@shared/components/ScrollToTop';
import { AppErrorBoundary } from '@dashboard/components/AppErrorBoundary';

export default function App() {
  return (
    <AppErrorBoundary fullScreen>
      <SWRConfig>
        <BrowserRouter>
          <ScrollToTop />
          <Routes />
        </BrowserRouter>
      </SWRConfig>
    </AppErrorBoundary>
  );
}
